import { Component } from "@angular/core";

@Component({
  selector: "user-guide-page",
  templateUrl: "user-guide.page.html"
})
export class UserGuidePage {
  constructor(
  ) {
    // No empty block
  }

}



// WEBPACK FOOTER //
// ./src/pages/user-guide.page/user-guide.page.ts